"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IntermediateLookupResolverConditionBuilder_1 = __importDefault(require("./IntermediateLookupResolverConditionBuilder"));
var IntermediateResolverConditionBuilder_1 = __importDefault(require("./IntermediateResolverConditionBuilder"));
var IntermediateContextHolder_1 = __importDefault(require("./IntermediateContextHolder"));
var Variant_1 = require("../../behaviorManager/constants/Variant");
var ParenthesisCondition_1 = __importDefault(require("../ParenthesisCondition"));
var IntermediateContextualConditionBuilder_1 = __importDefault(require("./IntermediateContextualConditionBuilder"));
var IntermediateConfigConditionBuilder_1 = __importDefault(require("./IntermediateConfigConditionBuilder"));
var WhiteLabelConfigExtractor_1 = __importDefault(require("../../extractor/WhiteLabelConfigExtractor"));
var IntermediateBuilder = (function () {
    function IntermediateBuilder(context) {
        this.context = context;
    }
    Object.defineProperty(IntermediateBuilder.prototype, "not", {
        get: function () {
            return new IntermediateBuilder(__assign(__assign({}, this.context), { invert: !this.context.invert }));
        },
        enumerable: false,
        configurable: true
    });
    IntermediateBuilder.prototype.with = function (rConditionBuilder) {
        return new IntermediateContextHolder_1.default(this.context).performPendingOperation(new ParenthesisCondition_1.default(rConditionBuilder.build()));
    };
    Object.defineProperty(IntermediateBuilder.prototype, "experiment", {
        get: function () {
            return new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.Experiment, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "origin", {
        get: function () {
            return new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.Origin, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "culture", {
        get: function () {
            return new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.Culture, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "deviceType", {
        get: function () {
            return new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.DeviceType, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "whiteLabelId", {
        get: function () {
            return new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.WhiteLabelId, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "whiteLabelFeature", {
        get: function () {
            return new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.WhiteLabelFeature, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "domainName", {
        get: function () {
            return new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.DomainName, this.context);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IntermediateBuilder.prototype, "serverSide", {
        get: function () {
            return new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.ServerSideBehavior, this.context);
        },
        enumerable: false,
        configurable: true
    });
    IntermediateBuilder.prototype.contextOf = function (name, predicate) {
        return new IntermediateContextualConditionBuilder_1.default(name, predicate, this.context);
    };
    IntermediateBuilder.prototype.whiteLabelConfig = function (featureName) {
        return new IntermediateConfigConditionBuilder_1.default('whiteLabelConfig', (0, WhiteLabelConfigExtractor_1.default)(featureName), this.context);
    };
    return IntermediateBuilder;
}());
exports.default = IntermediateBuilder;
